/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */
/*
DISCLAIMER - Just a reminder we don't want this to be a connected component because it sits outside of the store
for auth components and they use this to redirect to on failures
 */
import './ErrorPage.scss';

import React, { Fragment } from 'react';

import { ReactComponent as ErrorMessageImage } from 'assets/error-message.svg';
import { NON_BREAKING_SPACE } from 'services/Formats';
import { withoutTrailingSlash, footerLinks } from 'services/Externals';
import LinkButton from 'components/shared/Buttons/LinkButton';
import { getBaseUrl, GLOBALS, isInternalContext } from 'services/globals';
import { isSalesforceRepEnabled } from 'state/view/ViewSelectors';
import { connect } from 'react-redux';

const SUMMARY_MESSAGE = 'We are having technical issues loading your page.';

let pageLoadPath = (currentPath) => {
  //Nobody will hit try again in localhost - ignore it
  const baseUrl = isInternalContext(getBaseUrl())
    ? GLOBALS.AAM_UI_INTERNAL_BASE_URL
    : GLOBALS.AAM_UI_EXTERNAL_BASE_URL;
  const errorIndex = currentPath && currentPath.indexOf('error');

  if (currentPath && errorIndex) {
    currentPath = currentPath.substring(0, errorIndex);
  } else {
    currentPath = '/dashboard';
  }
  if (currentPath === '/') {
    currentPath = '/dashboard';
  }
  return withoutTrailingSlash(
    baseUrl + GLOBALS.AAM_UI_TRP_APP_CONTEXT + currentPath
  );
};

const DefaultErrorMessage = ({ currentPath }) => {
  let pathName = currentPath;
  const errorIndex = currentPath && currentPath.indexOf('error');
  if (errorIndex !== 1) {
    pathName = currentPath ? currentPath.substring(0, errorIndex - 1) : '';
  }

  const baseUrl = getBaseUrl();

  return (
    <div className="error-page-message">
      <div>
        Please try again or{NON_BREAKING_SPACE}
        <a href={footerLinks.contactUsUrl} className="error-page-link">
          contact us
        </a>
        {NON_BREAKING_SPACE}for assistance.
        <div>
          <LinkButton
            text="Try Again"
            link={pageLoadPath(currentPath)}
            className="error-page-try-again"
          />
        </div>
        {pathName !== '/dashboard' && pathName !== '/error' && (
          <div className="error-page-return">
            <a
              className="error-page-link"
              href={`${baseUrl}${GLOBALS.AAM_UI_TRP_APP_CONTEXT}/dashboard`}>
              Return to Dashboard
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

const SalesforceErrorMessage = ({ currentPath }) => {
  return (
    <div className="error-page-message">
      <div>
        <span>Please try again.</span>
        <div>
          <LinkButton
            text="Try Again"
            link={pageLoadPath(currentPath)}
            className="error-page-try-again"
          />
        </div>
      </div>
    </div>
  );
};

const ErrorPage = ({
  children,
  isSalesforceRepEnabled,
  summaryMessage = SUMMARY_MESSAGE,
  history
}) => {
  return (
    <Fragment>
      <div className="error-page-container">
        <div className="error-page-content">
          <div className="error-page-icon">
            <ErrorMessageImage />
          </div>
          <div className="error-page-title">
            {summaryMessage}
            {isSalesforceRepEnabled ? (
              <span>
                {
                  <SalesforceErrorMessage
                    currentPath={history && history.location.pathname}
                  />
                }
              </span>
            ) : (
              <span>
                {children || (
                  <DefaultErrorMessage
                    currentPath={history && history.location.pathname}
                  />
                )}
              </span>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  isSalesforceRepEnabled: isSalesforceRepEnabled(state)
});

export default connect(mapStateToProps)(ErrorPage);
